import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/2724cb704a1ac3dfbb01f8a7ab88df70.png"
                alt="InstaVisible"
                className="h-10 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-500'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('video-demo')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-500'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Demo
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-500'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-500'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-500'
                  : 'text-white hover:text-orange-400'
              }`}
            >
              Contact
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href="https://calendly.com/instavisible/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 bg-orange-500 text-white text-sm font-semibold rounded-full hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap inline-block"
            >
              Book a Demo
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('features')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('video-demo')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Demo
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
            <a
              href="https://calendly.com/instavisible/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center px-4 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Book a Demo
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
